import { BackButton } from "./BackButton";
import { FutureMoneyLogo } from "./FutureMoneyLogo";
import { ProgressBar } from "./ProgressBar";
import { RightButton } from "./RightButton";
import { Placeholder } from "./RightButton/styles";
import { OnboardingContainer, useStyles } from "./styles";
import { OnboardingHeaderProps } from "./types";

export const OnboardingHeader = ({ hideLogout = false }: OnboardingHeaderProps) => {
  const styles = useStyles();

  return (
    <>
      <OnboardingContainer style={styles.header}>
        <BackButton />
        <FutureMoneyLogo />
        {hideLogout ? <Placeholder /> : <RightButton />}
      </OnboardingContainer>
      <ProgressBar />
    </>
  );
};
